import { Component, ComponentRef, Inject, ViewChild, ChangeDetectorRef, inject, EnvironmentInjector } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-create-dialog',
  templateUrl: './create-dialog.component.html',
  styleUrls: ['./create-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,     // directives Angular de base + provider pour DOCUMENT
    IonicModule,      // composants Ionic
    MatIconModule     // icônes Angular Material
  ],
})
export class CreateDialogComponent {
  @ViewChild('componentHost', { read: ViewContainerRef }) componentHost!: ViewContainerRef;

  dialogTitleHeight!: any;
  dialogHeight!: any;

  matIcon: any;
  modalTitle: string = '';
  component: any;
  defaultValues: any;
  fixedValues: any;
  id: any;
  private envInjector = inject(EnvironmentInjector);
  private document = inject(DOCUMENT);
  
  constructor(
    private modalCtrl: ModalController,
    private cdRef: ChangeDetectorRef
  ) {}

  ionViewDidEnter() {
    this.loadDynamicComponent();
  }

  loadDynamicComponent() {
    // Crée dynamiquement le composant
    // const componentRef = this.componentHost.createComponent(this.component) as ComponentRef<any>;
    let componentRef: ComponentRef<any>;
    try {
      componentRef = this.componentHost.createComponent(this.component, { injector: this.envInjector });
      // Injection des props
      componentRef.instance.id = this.id;
      componentRef.instance.fixedValues = this.fixedValues;
      componentRef.instance.defaultValues = this.defaultValues;

      // Gestion de l’événement submit
      if (componentRef.instance.resSubmitEvent) {
        componentRef.instance.resSubmitEvent.subscribe((data: any) => {
          if (data) {
            this.modalCtrl.dismiss(data, 'confirm');
          } else {
            this.modalCtrl.dismiss(data, 'cancel');
          }
        });
      }

      // this.componentHost.insert(componentRef.hostView);
      componentRef.changeDetectorRef.detectChanges();
      this.initDocumentHeight();
      this.cdRef.detectChanges()
      
    } catch(e: any) {
      console.error('Error creating component:', e);
      console.log('Token path:', e.ngTokenPath); // Affiche les tokens minifiés
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  private initDocumentHeight() {
    this.dialogHeight = (this.document?.getElementsByTagName('app-create-dialog')[0] as HTMLElement)?.offsetHeight;
    this.dialogTitleHeight = this.document?.getElementById('dialog-title')?.offsetHeight;
  }
}
